import { ComponentProps } from "react";
import Statistics from "../Statistics";
import { CompareTo, Range, alignRows, sumRows } from "./data";
import { ComparisonQuery, useComparison } from "./useComparison";

type Props = Omit<ComponentProps<typeof Statistics>, "hours" | "compare"> & {
  query: Omit<ComparisonQuery, "subjectIds">;
  compareTo: CompareTo;
  onCompareTo: (compareTo: CompareTo) => void;
  onComparedRange: (range: Range) => void;
};

/**
 * Insights' summary bar: today's bar plus Hours and compare mode. Revenue and
 * Cost are the page's own read of the picked dates, as on Activity and in
 * Financial Breakdown; Hours and the compared dates come from the same days
 * as the chart and the table. Each change is the value shown less the
 * compared value shown.
 */
export default function Summary({
  query,
  compareTo,
  onCompareTo,
  onComparedRange,
  ...bar
}: Props) {
  const { data, loading } = useComparison({ ...query, subjectIds: [] });
  const rows = data
    ? alignRows(data.current.buckets, data.compared?.buckets ?? null)
    : [];
  const compared = data?.compared ? sumRows(rows, "compared") : null;
  return (
    <Statistics
      {...bar}
      hours={data ? sumRows(rows, "current").hours : null}
      dim={loading}
      compare={{
        to: compareTo,
        onTo: onCompareTo,
        range: query.compared ?? query.range,
        onRange: onComparedRange,
        totals: compared && {
          revenue: compared.revenue,
          cost: compared.tutor_pay,
          hours: compared.hours,
        },
      }}
    />
  );
}
